import { useCallback } from 'react';
import axios, { useApiRequest } from './axios';
import { ChangeEmailRequest, ChangeEmailPincodeRequest, CurrentUserResponse, UpdateCurrentUserRequest } from '../types/users';

const CURRENT_USER_URL = '/users/current-user/';
const CHANGE_EMAIL_URL = '/users/change-email/';
export const USERS_URL = '/users/users/';

export const getReactivateUserUrl = (id: string) => `${USERS_URL}${id}/reactivate/`;

export const useCurrentUser = () => {
  const { loading, error, executeRequest } = useApiRequest();

  const query = useCallback(async (): Promise<CurrentUserResponse | undefined> => {
    const { data } = await executeRequest(() => axios.get(CURRENT_USER_URL));
    return data;
  }, [executeRequest]);

  const update = useCallback(async (data: UpdateCurrentUserRequest): Promise<any | undefined> => {
    const { data: responseData, success } = await executeRequest(() =>
      axios.patch(CURRENT_USER_URL, data)
    );
    return { data: responseData, success };
  }, [executeRequest]);

  return { loading, error, query, update };
};

export const useChangeEmail = () => {
  const { loading, error, executeRequest } = useApiRequest();

  const changeEmailMutation = useCallback(async (data: ChangeEmailRequest): Promise<any | undefined> => {
    const { data: responseData, success } = await executeRequest(() =>
      axios.post(CHANGE_EMAIL_URL, data)
    );
    return { data: responseData, success };
  }, [executeRequest]);

  const changeEmailPincodeMutation = useCallback(async (data: ChangeEmailPincodeRequest): Promise<any | undefined> => {
    const { data: responseData, success } = await executeRequest(() =>
      axios.put(CHANGE_EMAIL_URL, data)
    );
    return { data: responseData, success };
  }, [executeRequest]);

  return { loading, error, changeEmailMutation, changeEmailPincodeMutation };
};

export const useReactivateUser = () => {
  const { loading, error, executeRequest } = useApiRequest();

  const reactivate = useCallback(async (id: string): Promise<{ success: boolean; errorData?: any }> => {
    const { success, errorData } = await executeRequest(() =>
      axios.post(getReactivateUserUrl(id))
    );
    return { success: !!success, errorData };
  }, [executeRequest]);

  return { loading, error, reactivate };
};
